import type { IEntityModel } from './base'

export enum IQuestionnaireDisplayRuleSourceType {
  Section = 'section',
  Question = 'question',
}

export interface IQuestionnaireDisplayRuleSource extends IEntityModel {
  displayRuleId: string
  type: IQuestionnaireDisplayRuleSourceType
  questionnaireSectionId?: string // foreign key
  questionnaireQuestionId?: string // foreign key
}

export interface IQuestionnaireDisplayRuleSourceSection
  extends IQuestionnaireDisplayRuleSource {
  type: IQuestionnaireDisplayRuleSourceType.Section
  questionnaireSectionId: string
}

export interface IQuestionnaireDisplayRuleSourceQuestion
  extends IQuestionnaireDisplayRuleSource {
  type: IQuestionnaireDisplayRuleSourceType.Question
  questionnaireQuestionId: string
}
